import React from 'react';
import {Alert, Form, Input, Select, Skeleton, Result, message} from 'antd';
import { useParams } from "react-router-dom";
import { useQuery, useMutation } from "react-query";
import {UpdateDeveloperAccount, GetDeveloper} from "../../../../../api/console";
import { DeveloperForm } from "../../CreateProfile";


export const EditAccountController = (props) => {

    const params = useParams();
    const { developer_id } = params;

    const DeveloperResponse = useQuery(
        ['developer', developer_id],
        () => GetDeveloper(developer_id)
    );

    const UpdateDeveloperMutation = useMutation(
        (data) => UpdateDeveloperAccount(developer_id, data),
        {
            onSuccess: (data, vars) => {
                message.success(`Аккаунт успешно обновлен`);
            },
            onError: (e) => {
                console.error(`[UpdateDeveloperMutation] `, e.response);
                message.error(e?.response?.data?.message || "Во время запроса произошла ошибка");
            }
        }
    )


    if (DeveloperResponse.isLoading) {
        return (
            <div className={`dev__layout account`}><Skeleton /></div>
        )
    }

    const profile = DeveloperResponse?.data?.developer || {};
    const isOwner = DeveloperResponse?.data?.is_owner || false;

    return (
        <div className={`dev__layout account`}>
            <h1>Редактирование аккаунта</h1>
            <div className="account__form wp">
                {DeveloperResponse.isSuccess && (
                    isOwner ? <DeveloperForm
                            profile={profile}
                            developerType={profile.type || false}
                            hideTitle={true}
                            buttonText={`Обновить аккаунт`}
                            isLoading={UpdateDeveloperMutation.isLoading}
                            createProfile={(data) => {
                                UpdateDeveloperMutation.mutate(data)
                            }}
                            initialValue={{
                                country_id: profile?.location.country_id || null,
                                region_id: profile?.location.region_id || null,
                                city_id: profile?.location.city_id || null,
                                address: profile?.location.address || "",
                                phone: profile?.company.phone || "",
                                email: profile?.company.email || "",
                                title: profile?.company.title || "",
                                website: profile?.company.website || "",
                                contact_name: profile?.company.contact_name || "",
                                contact_position: profile?.company.contact_position || "",
                                inn: profile?.company.inn || "",
                            }}
                        /> : <Result
                        status="warning"
                        title={`Только валедец аккаунта может просматривать и редактировать информацию об аккаунте`}
                    />
                )}
                {DeveloperResponse.isError && (
                    <Result
                        status="warning"
                        title={`Во время загрузки аккаунта произошли ошибки`}
                        subTitle={`Попробуйте позднее`}
                    />
                )}

            </div>
        </div>
    );
}

export default EditAccountController;